var exports = {
  "Tp": "xe7b6e3d6--8f72c0--background",
  "iE": "xe7b6e3d6--8f72c0--wrapper",
  "DD": "xe7b6e3d6--8f72c0--title",
  "VO": "xe7b6e3d6--8f72c0--full-width",
};

module.exports = exports;
